import { rootApi } from '../rootApi';

/**
 * LMS Eğitim İçeriği ve Kazanımları — `/v1.0/LmsTrainingContentOutput`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §5.
 *
 * Kayıt anahtarı `trainingId`'dir, bir eğitimin tek içerik/kazanım kaydı olur ve bu kayıt
 * 6 dilin tamamını `translations` dizisinde tutar. `GetByTrainingId` kayıt yoksa 404 döner —
 * bu normal bir durumdur (eğitimin henüz içerik/kazanım kaydı açılmamış demektir), FE bunu
 * `error?.status === 404` kontrolüyle "boş form + Add" akışına çevirmelidir (bkz. hooks/useTrainingContentOutputData.js).
 */
export const lmsTrainingContentOutputApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingContentOutputs: builder.query({
            query: ({ trainingId, trainingCode, text, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingContentOutput/GetList',
                method: 'POST',
                body: {
                    trainingId: trainingId ?? null,
                    trainingCode: trainingCode || null,
                    text: text || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingContentOutput']
        }),

        getLmsTrainingContentOutputByTrainingId: builder.query({
            query: (trainingId) => ({
                url: 'v1/LmsTrainingContentOutput/GetByTrainingId',
                method: 'GET',
                params: { trainingId }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingContentOutput']
        }),

        addLmsTrainingContentOutput: builder.mutation({
            query: ({ trainingId, translations }) => ({
                url: 'v1/LmsTrainingContentOutput/Add',
                method: 'POST',
                body: { trainingId, translations }
            }),
            invalidatesTags: ['LmsTrainingContentOutput']
        }),

        updateLmsTrainingContentOutput: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingContentOutput/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingContentOutput']
        }),

        deleteLmsTrainingContentOutput: builder.mutation({
            query: (trainingId) => ({
                url: `v1/LmsTrainingContentOutput/${trainingId}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTrainingContentOutput']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingContentOutputsQuery,
    useGetLmsTrainingContentOutputByTrainingIdQuery,
    useAddLmsTrainingContentOutputMutation,
    useUpdateLmsTrainingContentOutputMutation,
    useDeleteLmsTrainingContentOutputMutation
} = lmsTrainingContentOutputApi;
